import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { GetErrorPageUrl } from "src/actions/GetErrorPageUrl";
import { getSelectedProvider } from "src/actions/SelectProvider";
import { LoadingRedirect } from "src/components/LoadingRedirect/LoadingRedirect";

const TIMEOUT_REDIRECT = 3000;

export const RedirectProvider = () => {
  const provider = getSelectedProvider();
  const providerUrl = localStorage.getItem("providerUrl");
  const navigate = useNavigate();

  useEffect(() => {
    if (!providerUrl) return;

    setTimeout(() => {
      // starts with / means that is a internal route
      if (providerUrl.startsWith("/")) {
        return navigate(providerUrl);
      }

      window.location.href = providerUrl;
    }, TIMEOUT_REDIRECT);
  }, [navigate, providerUrl]);

  if (!provider || !providerUrl) {
    return <Navigate to={GetErrorPageUrl()} />;
  }

  return (
    <LoadingRedirect
      logo={provider.logo_white ?? ""}
      name={provider.name ?? ""}
    />
  );
};
